export default "__VITE_ASSET__v3Cpjj3S__"